import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

import { clickAsLink } from 'helpers/link_helpers';
import { isPresent, valueOrPlaceholder } from 'helpers/string_helpers';
import SelectableRow from 'components/selectable_record_table/selectable_row';

import { toggleSelectCompany } from '../store/actions/select_list';
export class CompanyRow extends React.Component {
  static propTypes = {
    allCompaniesIds: PropTypes.array.isRequired,
    callId: PropTypes.number,
    canPreview: PropTypes.func.isRequired,
    company: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      url: PropTypes.string,
      lastUpdated: PropTypes.string.isRequired,
      showPath: PropTypes.string.isRequired
    }).isRequired,
    crmEmail: PropTypes.string,
    currentColumns: PropTypes.array.isRequired,
    selected: PropTypes.bool.isRequired,
    updatePreviewOverlay: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  handleClick = (e) => {
    const { allCompaniesIds, company: { showPath, id } } = this.props;

    const offset = allCompaniesIds.findIndex(num => num == id);
    const href = `${showPath}?offset=${offset}`;

    if (href) {
      clickAsLink(window, href, e);
    }
  };

  handlePreview = () => {
    const {
      company: { id },
      updatePreviewOverlay
    } = this.props;

    updatePreviewOverlay(id);
  }

  handleSelect = () => {
    const { company, onSelect } = this.props;

    onSelect(company);
  };

  renderPreviewButton() {
    const { callId, canPreview } = this.props;

    let tooltipPrompt;
    if (callId) tooltipPrompt = 'You cannot preview another company while on a call';
    const previewToolTip = (
      <Tooltip id="preview-tooltip" placement="top">
        <span>
          {tooltipPrompt}
        </span>
      </Tooltip>
    );

    if (callId) {
      return (
        <OverlayTrigger overlay={previewToolTip} placement="top">
          <button
            className="btn btn-sm btn-hover btn-muted disabled"
          >
            PREVIEW
          </button>
        </OverlayTrigger>
      );
    } else {
      return (
        <button
          className="btn btn-sm btn-hover btn-muted"
          disabled={!canPreview()}
          onClick={this.handlePreview}
        >
          PREVIEW
        </button>
      );
    }
  }

  render() {
    const { company } = this.props;

    return (
      <SelectableRow
        selected={this.props.selected}
        onChange={this.handleSelect}
      >
        <td className="border-end-0">
          <strong
            className="contact-link overflow-span"
            onClick={this.handleClick}
          >
            {valueOrPlaceholder(company.name)}
          </strong>
          <div className="d-md-none">
            {company.useTruncatedAddress ? company.addressTruncated : company.addressOneLine }
          </div>
        </td>
        <td className="d-none d-md-table-cell auto-size">
          {this.renderPreviewButton()}
        </td>
        <td className="d-none d-md-table-cell">
          {valueOrPlaceholder(company.databaseName)}
        </td>
        <td className="d-none d-md-table-cell">
          {company.useTruncatedAddress ? company.addressTruncated : company.addressOneLine }
        </td>
        <td className="d-none d-md-table-cell">{company.url}</td>
        <td className="d-none d-md-table-cell">{company.lastUpdated}</td>
        {this.renderSearchResults()}
        {this.renderCurrentColumns()}
      </SelectableRow>
    );
  }

  renderCurrentColumns() {
    const { currentColumns, company } = this.props;

    const columns = [];

    currentColumns.forEach((column) => {
      columns.push(
        <td className="d-none d-md-table-cell">
          {valueOrPlaceholder(company[column])}
        </td>
      );
    });

    return columns;
  }

  renderSearchResults() {
    const { company } = this.props;

    if (company && company.searchResults) {
      const highlights = Object.entries(company.searchResults);

      if (highlights.length > 0) {
        const [label, value] = highlights[0];
        const formattedValue = <span dangerouslySetInnerHTML={{ __html: value }} />;

        if (isPresent(label)) {
          return (
            <td className="d-none d-md-table-cell" name="search-results">
              <span name="search-result-label">{label}:</span>&nbsp;
              <span name="search-result-value">"{formattedValue}"</span>
            </td>
          );
        } else {
          return (
            <td className="d-none d-md-table-cell" name="search-results">
              <span name="search-result-value">
                {formattedValue}
              </span>
            </td>
          );
        }
      }
    }
  }
}

const mapStateToProps = state => ({
  allCompaniesIds: state.search.meta.companies.allIds,
  callId: state.ui.previewOverlayCallId,
  currentColumns: state.session.currentColumns,
  crmEmail: state.static.crmEmail
});

const mapDispatchToProps = {
  onSelect: toggleSelectCompany,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRow);
